import React, { useEffect, useState } from "react"
import { Col, Row } from "reactstrap"

// import ManageTrailer from "./ManageTrailer"
import { AddInventorySettings, GetInventorySettings } from "api/api.service"
import { Button } from "../../../components/Button"
import { DataTable } from "../../../components/DataTable"

import delIcon from "assets/images/icons/finance-vendor-mang-del-icon.svg"
import { InventorySettings } from "constants"
import ConfirmationModal from "pages/Configurator/Trailers/ConfirmationModal"
import toast from "react-hot-toast"
import { SearchBox } from "components/SearchBox"
import ManageMoulds from "./ManageMoulds"

const initialModalValue = {
   isOpen: false,
   type: null,
}
const modalTypes = {
   ADD: "ADD",
   DELETE: "DELETE",
}
const COLUMNS = {
   CREATE_DATE: "Create Date",
   MOULD: "Mould",
   ACTIONS: "Actions",
}

const MouldsListing = ({}) => {
   const [selection, setSelection] = useState({})
   const [isLoading, setIsLoading] = useState(false)
   const [data, setData] = useState(null)
   const [searchText, setSearchText] = useState("")
   const [isDeleteLoading, setIsDeleteLoading] = useState(false)
   const [isAddLoading, setIsAddLoading] = useState(false)
   const [modal, setModal] = useState(initialModalValue)

   const filteredData = data?.filter(item =>
      item?.color?.toLowerCase().includes(searchText.toLowerCase())
   )
   const fetchDetails = async () => {
      try {
         setIsLoading(true)
         const payload = {
            inventorySettingsType: InventorySettings.MouldConfiguration,
         }
         const res = await GetInventorySettings(payload)
         const moulds =
            res?.inventorySettingsTypeValue?.MouldConfiguration || []
         setData(moulds)
      } catch (err) {
      } finally {
         setIsLoading(false)
      }
   }
   useEffect(() => {
      fetchDetails()
   }, [])

   const handleOpenModal = (obj, modalType) => {
      setModal({ isOpen: true, type: modalType })
      setSelection(obj)
   }
   const handleCloseModal = () => {
      setModal(initialModalValue)
      setSelection(null)
   }

   const patchMould = async existingMoulds => {
      try {
         const payload = {
            inventorySettingsType: "MouldConfiguration",
            inventorySettingsTypeValue: {
               MouldConfiguration: existingMoulds,
            },
         }

         await AddInventorySettings(payload)
      } catch (err) {}
   }
   const handleManageMould = async color => {
      try {
         setIsAddLoading(true)
         const newColors = [...data, { color: color.value }]
         await patchMould(newColors)
         await fetchDetails()
         toast.success("Mould added successfully!")
      } catch (err) {
      } finally {
         setIsAddLoading(false)
         handleCloseModal()
      }
   }
   const handleDeleteModal = async () => {
      try {
         setIsDeleteLoading(true)
         const newColors = data?.filter(
            color => color.color != selection?.color
         )
         await patchMould(newColors)
         await fetchDetails()
         toast.success("Mould removed successfully!")
      } catch (err) {
      } finally {
         setIsDeleteLoading(false)
         handleCloseModal()
      }
   }

   const formConfig = [
      {
         title: COLUMNS.MOULD,
         render: data => (
            <div>
               <div
                  className={`mould-color mould-radius mould-color-${data?.color?.toLowerCase()}`}
               >
                  <p>{data?.color}</p>
               </div>
            </div>
         ),
      },

      {
         title: COLUMNS.ACTIONS,

         render: data => (
            <div className="ml-2 tooltip-container">
               <img
                  src={delIcon}
                  onClick={() => handleOpenModal(data, modalTypes.DELETE)}
               />
               <span className="custom-tooltip">Delete</span>
            </div>
         ),
      },
   ]

   return (
      <>
         <div className="mb-3 trailer-container"></div>

         <div className="mb-3">
            <div className="d-flex align-items-center justify-content-end gap-3 admin-inventory-management-general-inventory-responsiveness ">
               <div className="d-flex align-items-center justify-content-end admin-inventory-management-general-inventory-responsiveness trailer-btn-container">
                  <Button
                     className={`header-button headerButtonResponsive`}
                     title="Add Mould"
                     onClick={() => handleOpenModal(null, modalTypes.ADD)}
                  />
               </div>{" "}
               <div className="ad-location-search-box">
                  <SearchBox
                     inputClasses="vendor-search-input input-search"
                     labelClass="d-none"
                     placeholder="Search"
                     searchIcon={true}
                     searchIconClass="vendor-table-search-icon"
                     conClass="vendor-table-search-inner-class"
                     searchText={searchText}
                     onChange={e => setSearchText(e.target.value)}
                  />
               </div>
            </div>
         </div>
         <Row>
            <Col md={12}>
               <DataTable
                  data={filteredData}
                  tableClasses="trailer-management-table"
                  className="table-responsive"
                  loading={isLoading}
                  config={formConfig}
               />
            </Col>
         </Row>
         {modal.isOpen && modal.type == modalTypes.DELETE && (
            <ConfirmationModal
               isOpen={modal.isOpen && modal.type == modalTypes.DELETE}
               actionName={"Delete"}
               entityName={"Mould"}
               isLoading={isDeleteLoading}
               handleNo={handleCloseModal}
               handleYes={handleDeleteModal}
               toggleFunction={handleCloseModal}
            />
         )}
         {modal.isOpen && modal.type == modalTypes.ADD && (
            <ManageMoulds
               isOpen={modal.isOpen && modal.type == modalTypes.ADD}
               onToggleModal={handleCloseModal}
               onSuccess={handleManageMould}
               colors={data.map(color => color.color)}
               isLoading={isAddLoading}
            />
         )}
      </>
   )
}

export default MouldsListing
